// extracted by mini-css-extract-plugin
export default {"menuIcon":"card-stack-menu_menuIcon__ExcNm"};